/**
 * Validates required fields in a data object.
 * @param {Object} data - The data object to validate.
 * @param {Array} requiredFields - Array of field definitions { key, label }.
 * @returns {Object} - An object containing error messages for missing fields.
 */
export function validateRequiredFields(data, requiredFields) {
  const errors = {};
  requiredFields.forEach((field) => {
    const value = data[field.key];
    if (
      value === null ||
      value === undefined ||
      value === "" ||
      value === 1e-14 ||
      (Array.isArray(value) && value.length === 0)
    ) {
      const formattedLabel =
        field.label.charAt(0).toUpperCase() +
        field.label.slice(1).toLowerCase();
      errors[field.key] = `${formattedLabel} is required`;
    }
  });
  return errors;
}
